import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "use"];
import { useCallback, useContext } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { SectionContext } from '../../../context/SectionContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeActionButton = ({
  breezeActionButton,
  props,
  tooltip
}) => {
  const {
    label
  } = breezeActionButton;
  const {
      disabled,
      use
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    isWaitingForChatResponse,
    onBreezeActionClicked
  } = useContext(SectionContext);
  const onClick = useCallback(() => {
    onBreezeActionClicked === null || onBreezeActionClicked === void 0 || onBreezeActionClicked(breezeActionButton);
  }, [breezeActionButton, onBreezeActionClicked]);
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "200px",
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltip,
      delay: BREEZE_TOOLTIP_DELAY,
      children: /*#__PURE__*/_jsx(Button, Object.assign({
        disabled: isWaitingForChatResponse || breezeActionButton.isDisabled || disabled,
        onClick: onClick,
        size: "xs",
        use: use !== null && use !== void 0 ? use : 'tertiary-on-fill',
        truncate: true,
        width: "fit-content",
        borderRadius: "full"
      }, restProps, {
        children: label
      }))
    })
  });
};